import myHeader from "../../components/header.vue";
import CameraDialog from "../../components/CameraDialog/CameraDialog.vue";
import examDialog from "../../components/examDialog/examDialog.vue";
import { pUrl } from "@/api/baseURL.js";
import { eUrl } from "@/api/baseURL.js";
import PdfViewer from "../../components/PdfViewer";
import { saveAs } from 'file-saver';
import replaceVideo from './replaceVideo'

import {
  getEntpCourseConfigCurrent,
  getUserCourseStudyDetail,
  getStudyccCountToday,
  saveUserStudyTime,
  saveStudyPhoto,
  addCourseComment,
  getCourseCommentListHome,
  getEnterpriseWebsite,
  saveTrainQuestionnaire,
  getVideoIds
} from "../../apiCloud/coursePlay";
import { noticeInLearning } from "@/apiCloud/noticeBox";
let that;
// let oldTokenId=localStorage.getItem("tokenId")

//检测电脑设备是否已经安装了摄像头
if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
  // Firefox 38+ seems having support of enumerateDevicesx
  navigator.enumerateDevices = function(callback) {
    navigator.mediaDevices.enumerateDevices().then(callback);
  };
}
var MediaDevices = [];
var isHTTPs = location.protocol === "https:";
var canEnumerate = false;

if (
  typeof MediaStreamTrack !== "undefined" &&
  "getSources" in MediaStreamTrack
) {
  canEnumerate = true;
} else if (
  navigator.mediaDevices &&
  !!navigator.mediaDevices.enumerateDevices
) {
  canEnumerate = true;
}

var hasMicrophone = false;
var hasSpeakers = false;
var hasWebcam = false;

var isMicrophoneAlreadyCaptured = false;
var isWebcamAlreadyCaptured = false;

export default {
  // components: {
  //   myHeader
  // },
  components: {
    CameraDialog,
    examDialog,
    PdfViewer,
  },
  data() {
    return {
      firstTake: false, //课程10%是否拍过照
      midTake: false, //课程50%是否拍过照
      lastTake: false, //课程80%是否拍过照
      takePhotoInter: "", //定时器f
      isWatch: "", //定时器实时告诉浏览器有一个课再看
      // 看课拍照参数
      courseConfig: {
        camera: false,
        completeRateFlag: 90,
        canDrop: "on"
      },
      dialogTableVisible: false,
      djsTime: 0,
      imgUrl: "", // 拍摄的照片路径
      timeOut: null, // 拍照定时器
      takePhotoTime: 600000, //定时拍照时间
      takePhotoCount: 1, //定时拍照次数
      needPhotoCount:1, //需要拍照次数
      select: "hh",
      player: null,
      playTime: 0,
      show: true,
      liSelected: "100",
      playHeight: "400",

      remove: false,
      current: -1,
      vid: "",
      ccId: "",
      start: 0,
      courseOver: "",
      packagebagId: "",
      courseId: "",
      empStudyId: "",
      courseName: "",
      overStatus: "",
      intervalid1: null,
      interval: null,
      autoPlay: true,
      baseInfoCatalogList: [],
      empHeadportrait: "",
      coursePic: "",
      resouceHours: 0,
      isSave: false,
      playData: {},
      oldTokenId: "",
      oldPlayTime: 0,
      playObj: {},
      abnormalOldPlayTime: 0,
      regId: "",
      tabLeftType: "目录",
      resData: {},
      formRecord: {},
      courseCommentListHome: [],
      heightAuto: {
        height: window.innerHeight - 350 + "px"
      },
      sysOrder: "",
      radioPl: 0,
      visible: false,
      noticeData: "",
      sTimeoutNotice: "",
      evaluationVisible: false,
      questionnaireUrl: "",
      courseIdList: [],
      practicePopupDialog: false, //弹练习
      goExerciseId: "",
      ccName: "",
      pdfLink:'',
      currentPage: 1,
      pageCount: 0,
      isPdf:false,
      isQuestionShow:false, //是否显示调查问卷
      trainEvaluation:'', //培训评价
      trainEffect:'', //培训效果
      courseUsefulness:'', //课程实用性
      courseRichInteresting:'', //课程丰富
      trainInstructiveForWork:'', //培训对实际工作的指导性 
      courseContentSatisfaction:'', //课程内容满意度
      knowledgeMastery:'', //知识的掌握
      wishCourseForWhat:'', //希望培训课程
      teachingSatisfaction:'', //教学满意度
      teachingContentAccept:'', //教学内容接受程度
      meetExpectations:'', //满足预期
      masteryAbilityForOver:'', //掌握能力知识
      recommendations:'', //建议
      comparison:0, //是否照片比对（0、否 1、是）
      satisficing:0, //是否填写满意度调查问卷（0、否 1、是）
      comparisonMsg:'',
      isDisabled:false,
      resDataStatus:-1,//是否显示继续看课按钮
      loadingPhoto:false, //拍照加载

      needPracticePhoto:0 // TODO 练习是否需要拍照
    };
  },
  beforeCreated() {},
  created() {
    this.oldTokenId = localStorage.getItem("oldTokenId");
    this.playData = JSON.parse(localStorage.getItem("playData")); //课程详情页面进入播放页面存入的播放所需参数
    console.log('课程详情进入参数',this.playData)
    this.goExerciseId = this.playData.exerciseId;
    this.ccName = this.playData.ccName;
    this.practicePlayFlag = this.playData.practicePlayFlag;
    this.packagebagId = this.playData.packagebagId;
    this.pdfLink = this.playData.coursewareUrl
    this.regId = this.playData.regId;
    if(this.playData.isPdf ==true){
      this.isPdf = true;
    }else{
      this.isPdf = false;
    }
    if (!this.regId) {
      this.$message.warning("reg错误");
      this.$router.push({
        path: "/studyCentre"
      });
      return;
    }
    this.courseId = this.playData.courseId;
    this.empHeadportrait = localStorage.getItem("empHeadportrait"); //获取学员头像
    // this.getCourseBaseInfoCatalog();
    that = this;
    that.getCourseCommentListHome("目录");
  },
  mounted() {
    this.getConfig();
    this.isWatch = setInterval(function() {
      localStorage.setItem("isWatch", "yes");
      // console.log("jianting")
    }, 1000);
    this.getScreenHeight();
  },
  beforeDestroy() {
    if (this.courseConfig.camera) {
      this.$refs.camera.stopNavigator();
    }
    if (this.courseConfig.camera2) {
      this.$refs.camera2.stopNavigator();
    }
    clearInterval(that.intervalid1);
    that.intervalid1 = null;
    clearInterval(that.interval);
    clearInterval(that.isWatch);
    that.interval = null;
    /**保利威替换 start */
    // that.player.destroy();
    /**保利威替换 end */
    // window.j2s_stopVideo()
    console.log("出去");
    localStorage.removeItem("video_on");
  },
  destroyed() {
    console.log("出去2");
  },
  methods: {
    handleBack(){
      const data = {
        path: '/courseDetail'
      }
      if(this.$route.query.studyEntpId){
        data.query = {
          studyEntpId:this.$route.query.studyEntpId
        }
      }
      this.$router.push(data)
    },
    //满意度调查提交事件
    onSubmit(){
      if(that.trainEvaluation ==''||
      that.trainEffect ==''||
      that.courseUsefulness ==''||
      that.courseRichInteresting ==''||
      that.trainInstructiveForWork =='' ||
      that.courseContentSatisfaction ==''||
      that.knowledgeMastery ==''||
      that.wishCourseForWhat ==''||
      that.teachingSatisfaction ==''||
      that.teachingContentAccept ==''||
      that.meetExpectations ==''||
      that.masteryAbilityForOver ==''||
      that.recommendations ==''){
      that.$message.warning({
        message: '请完成在线培训满意度调查',
        duration: 1000
      }); 
      return false;
    }else{
      let entpId =localStorage.getItem("enterpriseId")
      let data ={
        regId:Number(this.regId),
        entpId:entpId,
        trainEvaluation:this.trainEvaluation, //培训评价
        trainEffect:this.trainEffect, //培训效果
        courseUsefulness:this.courseUsefulness, //课程实用性
        courseRichInteresting:this.courseRichInteresting, //课程丰富
        trainInstructiveForWork:this.trainInstructiveForWork, //培训对实际工作的指导性
        courseContentSatisfaction:this.courseContentSatisfaction, //培训对实际工作的指导性
        knowledgeMastery:this.knowledgeMastery, //培训对实际工作的指导性
        wishCourseForWhat:this.wishCourseForWhat, //培训对实际工作的指导性
        teachingSatisfaction:this.teachingSatisfaction, //培训对实际工作的指导性
        teachingContentAccept:this.teachingContentAccept, //培训对实际工作的指导性
        meetExpectations:this.meetExpectations, //培训对实际工作的指导性
        masteryAbilityForOver:this.masteryAbilityForOver, //培训对实际工作的指导性
        recommendations:this.recommendations, //培训对实际工作的指导性
      }
      saveTrainQuestionnaire(data).then(res=>{
        if(res.code ==200){
          this.$message({
            type: "success",
            message: res.msg,
            duration: "2000"
          });
          this.isQuestionShow =false 
        }
      })
    }
    },
    // 检查是否有安装摄像头
    isWebcam() {},
    // 获取配置信息
    getConfig() {
      let data = {
        systemId: 0, // 系统ID
        courseId: this.courseId, // 课程ID
        packagebagId: this.packagebagId, // 包编号
        studyEntpId: this.$route.query.studyEntpId
      };
      getEntpCourseConfigCurrent(data).then(res => {
        // console.log(res, 'res');
        if (res.code == 200) {
          this.resData = res.data;
          this.questionnaireFlag = res.data.questionnaireFlag; //调查问卷状态
          this.questionnaireUrl = res.data.questionnaireUrl;
          this.practicePlayFlag = res.data.practicePlayFlag; //弹练习习题
          // TODO 练习是否需要拍照
          this.needPracticePhoto = res.data.needPracticePhoto
          this.comparison = res.data.comparison; //是否照片比对
          this.satisficing = res.data.satisficing; //是否填写满意度调查问卷
          if (this.resData.needLimit == 1) {
            this.resData.limitClassHour = null;
          }
          if (res.data == null) {
            this.courseConfig.camera = false;
            this.courseConfig.canDrop = "on";
            this.courseConfig.completeRateFlag = 90;
            this.getCourseBaseInfoCatalog();
          } else {
            this.courseConfig.completeRateFlag = res.data.videoRatio;
            if (res.data.needPhoto == 0) {
              this.courseConfig.camera = true;
              this.needPhotoCount = res.data.needPhotoCount;
              this.getCourseBaseInfoCatalog();
            } else {
              this.courseConfig.camera = false;
              this.getCourseBaseInfoCatalog();
            }
            if (res.data.canDrag == 1) {
              this.courseConfig.canDrop = "on";
            } else {
              this.courseConfig.canDrop = "off";
            }
          }
          if (this.courseConfig.camera) {
            if (this.playData.vid) {
              // 从目录点进来的
              // this.dialogTableVisible = true;
            }
          }
        }
      });
    },
    //清除定时器
    clearFaTimer() {
      clearInterval(this.isWatch);
      this.interval = null;
      // console.log("清除父组件定时器成功")
    },
    //获取目录和详情,调取播放器
    getCourseBaseInfoCatalog() {
      this.regId = localStorage.getItem("studyRegId") || this.regId;
      let data = {
        courseId: this.courseId,
        packagebagId: this.packagebagId,
        regId: this.regId
      };
      getUserCourseStudyDetail(data).then(res => {
        if (res.code == 200) {
          this.sysOrder = res.data.sysOrder;
          this.baseInfoCatalogList = res.data.courseCatalogList;
          // this.baseInfoCatalogList = replaceVideo(res.data.courseCatalogList);
          this.coursePic = res.data.coursePic;
          this.courseName = res.data.courseName;
          if (this.courseConfig.camera == true) {
            this.checkDeviceSupport(function() {
              if (hasWebcam == false) {
                console.log("没有摄像头！");
                that.$message.warning({
                  message: "没有摄像头，请安装摄像头！",
                  duration: 1000
                });
                clearInterval(that.isWatch);
                that.interval = null;
                setTimeout(() => {
                  // that.$router.go(-1);
                }, 2000);
                // history.go(-1);
                that.$router.push({
                  path: "/courseDetail",
                  query:{
                    studyEntpId: that.$route.query.studyEntpId
                  }
                });
                return false;
              } else {
                // that.$refs.camera.cameraCheck();  // h5调摄像头拍照(头像)
                if (isWebcamAlreadyCaptured == false) {
                  console.log("捕获摄像头失败，请重新安装摄像头！");
                  clearInterval(that.isWatch);
                  that.interval = null;
                  setTimeout(() => {
                    // that.$router.go(-1);
                  }, 2000);
                  that.$message.warning({
                    message: "捕获摄像头失败，请重新安装摄像头！",
                    duration: 1000
                  });
                  // history.go(-1);
                  that.$router.push({
                    path: "/courseDetail",
                    query:{
                      studyEntpId: that.$route.query.studyEntpId
                    }
                  });
                  return false;
                }
              }
              // if (hasMicrophone == false) {
              //   console.log("没有麦克风！");
              //   return false;
              // } else {
              //   if (isMicrophoneAlreadyCaptured == false) {
              //     console.log("捕获麦克风失败，请重新安装麦克风！");
              //     return false;
              //   }
              // }
            });
          }

          if (this.playData.vid) {
            /**保利威替换 start */
            // this.vid = this.playData.vid;
            /**保利威替换 end */
            /**播放器 start */
            let $vid =  this.playData.vid
            /**播放器 end */
            this.liSelected = this.playData.liSelected;
            // ----------------------------- start 已播放完的视频重新播放 -- 验证人脸 -- 弹出弹窗 start -----------------------------
            // if (this.courseConfig.camera && this.playData.courseOver == 1) {
            //   console.log('-------------------------wx-ddd-------------------------')
            //   this.dialogTableVisible = true;
            // }
            // ----------------------------- end 已播放完的视频重新播放 -- 验证人脸 -- 弹出弹窗 end -----------------------------
            if (!this.playData.courseDelayTime) {
              this.start = 0;
            } else {
              this.start = this.playData.courseDelayTime;
            }
            this.ccId = this.playData.ccId;
            this.resouceHours = this.playData.resouceHours;
            // this.autoPlay = true
            /**播放器 start */
            this.autoPlay = true;
            /**播放器 end */
            this.playerStart($vid); //播放器 此处加了一个入参
          } else {
            /**保利威替换 start */
            // this.vid = this.baseInfoCatalogList[0].cousecate[0].vid;
            /**保利威替换 end */
            /**播放器 start */
            let $vid =  this.baseInfoCatalogList[0].cousecate[0].vid;
            /**播放器 end */
            this.ccId = this.baseInfoCatalogList[0].ccId;
            // this.autoPlay = false
            this.playerStart(); 

            $("#player").css("display", "none");
            $("#buylink").css("display", "none");
            $("#startScreen").css("display", "block");
          }
          sessionStorage.setItem("practiceisFlag", true);
        }
      });
    },
    //播放器
    playerStart($vid) { //播放器 此处加了一个入参
      console.log($vid)
      let _this = this;
      // clearInterval(_this.timeOut);
      console.log("playerStart_wx");
      // this.courseConfig.camera = true;
      // if (_this.courseConfig.camera) { // 10分钟后进行课程拍照
      //   _this.timeOut = setTimeout(() => {
      //     _this.player.j2s_pauseVideo(); // 暂停播放当前视频
      //     _this.dialogTableVisible = true;
      //   }, 600000) // 600000
      // };
      _this.isSave = false;
      console.log("播放器生产前历史参数", _this.start);
      // _this.player = polyvObject('#player').videoPlayer({
      //   'width': 'auto',
      //   'height': _this.playHeight,
      //   'list_id': 'id',
      //   'forceH5': true,
      //   'speed': false,
      //   'ignoreIE': true,
      //   'ban_seek': _this.courseConfig.canDrop, // 是否禁止视频拖拽未播放区域(进度条拖动)
      //   // "autoplay": _this.autoPlay,
      //   "autoplay": false,
      //   // "autoplay": true,
      //   "watchStartTime": _this.start,
      //   'flashvars': {
      //     'allowscriptaccess': "always",
      //     'allowNetworking': "all",
      //     "setScreen": "16_9",
      //   },
      //   'vid': _this.vid
      // })

      // this.player = polyvPlayer({
      //   wrap: "#player",
      //   width: "auto",
      //   height: _this.playHeight,
      //   autoplay: false,
      //   vid: _this.vid,
      //   ban_seek: _this.courseConfig.canDrop,
      //   speed: false,
      //   watchStartTime: _this.start || 0
      //   // playsafe: 'c7cabb17-579c-42df-9e11-afc71ac6120b-c12678',
      //   // ts:'1649934545000',
      //   // sign:'de2234b62946998946275e2524696d59',
      //   // params:{'param2':'tony','param1':'1000',},
      // });
      

      console.log("打印播放器生成时各个属性", _this.player);
      if (_this.start > 0) {
        _this.oldPlayTime = _this.start;
      } else {
        _this.oldPlayTime = 0;
      }
      console.log('do:s2j_onVideoPlay',$vid)
      window.s2j_onVideoPlay = function() {
        console.log('开始监听播放')
        clearInterval(_this.intervalid1);
        _this.intervalid1 = null;
        clearInterval(_this.interval);
        _this.interval = null;
        //视频开始播放
        _this.intervalid1 = setInterval(() => {
          console.log('保存播放时间')
          if (_this.courseOver == 1) {
            _this.saveUserCourseStudingData(1);
          } else {
            _this.saveUserCourseStudingData(0);
          }
        }, 120000);
        _this.getCourseCatalog(1);
        _this.interval = setInterval(_this.render, 1000);
      };
      window.s2j_onVideoPause = function() {
        //视频暂停播放
        clearInterval(_this.intervalid1);
        clearInterval(_this.interval);
      };
      window.s2j_onPlayOver = function() {
        //视频播放完成
        clearInterval(_this.intervalid1);
        clearInterval(_this.interval);
        _this.autoPlay = false;
        _this.saveUserCourseStudingData(1);
        // if (_this.courseConfig.camera) {
        //   console.log('-------------------------wx-eee-555-------------------------')
        //   _this.dialogTableVisible = true;
        // }
        // $("#player").css("display", "none");
        // $("#buylink").css("display", "block");
        $("#startScreen").css("display", "none");
        let parent = _this.liSelected.split("-")[0];
        let child = _this.liSelected.split("-")[1];
        _this.baseInfoCatalogList.map((item, index) => {
          //播放完成之后立马显示已经完成的图标
          if (index == parent) {
            let cousecate = item.cousecate;
            cousecate.map((temp, sub) => {
              if (sub == child) {
                temp.courseOver = 1;
              }
            });
          }
        });
        setTimeout(function() {
          _this.getCourseCatalog();
        }, 500);
      };
      
      /**播放器start */
      //调整到最后改变vid，播放器自动播放视频
      //在此之前，startTime（播放开始时间），
      //  dragEnable（是否可拖拽）先改变好
      if($vid){
        this.vid = $vid 
      }
      /**播放器end */
    },
    ycyOnPlay(){
      console.log("ycyOnPlay")
      if(window.s2j_onVideoPlay){
        window.s2j_onVideoPlay()
      }
    },
    ycyOnPause(){
      console.log("ycyOnPause")
      if(window.s2j_onVideoPause){
        window.s2j_onVideoPause()
      }
    },
    ycyOnEnded(){
      console.log("ycyOnEnded")
      if(window.s2j_onPlayOver){
        window.s2j_onPlayOver()
      }
    },

    //保存视频时长
    saveUserCourseStudingData(isOver) {
      if (
        !localStorage.getItem("tokenId") ||
        localStorage.getItem("tokenId") == ""
      ) {
        /**保利威替换 start */
        // this.player.destroy();
         /**保利威替换 end */
        this.$alert("账号登录失效，请退出后重新登录！", "提示", {
          confirmButtonText: "确定",
          showClose: false,
          callback: action => {
            this.$router.push({
              name: "home"
            });
            sessionStorage.setItem("$isUserLogin", false);
          }
        });
      } else if (this.oldTokenId != localStorage.getItem("tokenId")) {
        //两个账号登陆
        /**保利威替换 start */
        // this.player.destroy();
        /**保利威替换 end */

        this.open();
      } else {
        let data = {
          packagebagId: this.packagebagId, // 套餐包Id
          regId: this.regId,
          courseId: this.courseId, // 课程Id
          // empStudyId: this.empStudyId?this.empStudyId:"null",
          ccId: this.ccId, //视频VID
          courseDelayTime: this.playTime, //视频播放时长
          courseOver: isOver,
          studyEntpId: this.$route.query.studyEntpId
        };
        let _this = this;
        saveUserStudyTime(data).then(res => {
          if (res.data.success == 'true') {
            if (isOver == 1) {
              isOver = 1;
              // this.courseOver = 1
              // sessionStorage.setItem("practiceisFlag", true)
              this.isSave = true; //当保存时长成功之后，不再进行二次保存
              console.log("setTimeout", this.isSave);
              setTimeout(function() {
                let parent = _this.liSelected.split("-")[0];
                let child = _this.liSelected.split("-")[1];
                that.baseInfoCatalogList.map((item, index) => {
                  //播放完成之后立马显示已经完成的图标
                  if (index == parent) {
                    let cousecate = item.cousecate;
                    cousecate.map((temp, sub) => {
                      if (sub == child) {
                        temp.courseOver = 1;
                      }
                    });
                  }
                });
              }, 3000);
              that.getCourseCatalog();
            } else {
              setTimeout(() => {
                that.getCourseCatalog();
              }, 3000);
            }
            return;
          }

          // 如果拍照打卡弹窗存在，则不显示错误信息
          if (this.dialogTableVisible) {
            return;
          }

          // ==================== begin 视频进度条异常，回退 begin ====================
          if (res.data.message && res.data.message.includes('视频观看进度异常，或未拍摄照片将回退视频进度节点')) {
            this.videoPlayError(res.data);
            return;
          }
          // ==================== end 视频进度条异常，回退 end ====================

          // ============================= begin 请先学完进行中的视频，不能跳跃学习 begin =============================
          if (res.data.message && res.data.message.includes('请先学完进行中的视频，不能跳跃学习')) {
            this.videoJumpError('请先学完进行中的视频，不能跳跃学习');
            return;
          }
          // ============================= end 请先学完进行中的视频，不能跳跃学习 end =============================
          if (res.code == 2202) {
            //登陆失效
            /**保利威替换 start */
            // this.player.destroy();
            /**保利威替换 end */
            this.$alert("账号登录失效，请退出后重新登录！", "提示", {
              confirmButtonText: "确定",
              showClose: false,
              callback: action => {
                this.$router.push({
                  name: "home"
                });
                sessionStorage.setItem("$isUserLogin", false);
              }
            });
            return;
          }

          if (res.code == 2203) {
            that.abnormalOldPlayTime = JSON.parse(
              JSON.stringify(that.oldPlayTime)
            );
            this.$message({
              type: "warning",
              message: res.message
            });
            that.play(
              that.playObj.vid,
              that.playObj.ccId,
              that.playObj.courseDelayTime,
              that.playObj.index,
              that.playObj.sub,
              that.playObj.courseOver,
              that.playObj.resouceHours,
              that.playObj.practicePlayFlag,
              that.playObj.exerciseId,
              that.playObj.ccName
            );
            /**保利威视频替换 start */
            // that.player.j2s_seekVideo(that.abnormalOldPlayTime);
            /**保利威视频替换 end */

            /**播放器 start */
            that.$refs.ycyPlayer.jumpToTime(that.abnormalOldPlayTime)
            /**播放器 end */
            return;
          }
          this.$message.error(res.message);
        });
      }
    },
    
    // ============================= begin 视频进度条异常，回退 begin =============================
    videoPlayError(res) {
      // 弹出确认框（无取消），暂停当前播放；确认后跳转到后端返回的时间点继续播放
      /**云播放器 start */
      this.$refs.ycyPlayer && this.$refs.ycyPlayer.pause();
      /**云播放器 end */
      this
        .$confirm(res.message || '视频播放异常，请重新播放', "提示", {
          confirmButtonText: "确认",
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          let playData = this.playData || {};
          let oldPlayData = JSON.parse(JSON.stringify(playData));
          // 设置回退视频进度
          oldPlayData.courseDelayTime = res.courseDelayTime;
          localStorage.setItem("playData", JSON.stringify(oldPlayData));
          // 多开
          localStorage.setItem('isWatch', "no")

          window.location.reload();
        });
    },
    // ============================= end 视频进度条异常，回退 end =============================
    
    // ============================= begin 请先学完进行中的视频，不能跳跃学习 begin =============================
    videoJumpError(res) {
      // 弹出确认框（无取消），暂停当前播放；确认后跳转到后端返回的时间点继续播放
      /**云播放器 start */
      this.$refs.ycyPlayer && this.$refs.ycyPlayer.pause();
      /**云播放器 end */
      this
          .$confirm(res || '视频播放异常，请重新播放', "提示", {
            confirmButtonText: "确认",
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            type: "warning",
          })
          .then(() => {
            this.$router.go(-1);
          });
    },
    // ============================= end 请先学完进行中的视频，不能跳跃学习 end =============================
    getEnterpriseWebsite() {
      //根据域名获取企业id
      // var eUrl = window.location.href;
      // var eUrl = 'http://snyg.e.eceping.net';
      // var eUrl="http://www.eceping.net"
      //  var eUrl="http://hnpx.enterprise.eceping.net"
      var param = {
        entpWebsite: eUrl /*eUrl.substring(0,eUrl.indexOf(":",5))*/
      };
      getEnterpriseWebsite(param).then(res => {
        if (res.code == 200) {
          localStorage.setItem("enterpriseId", res.data.entpId);
          localStorage.setItem("entpCreditNo", res.data.entpCreditNo);
        }
      });
    },
    //获取目录和详情
    getCourseCatalog(type) {
      let data = {
        courseId: this.courseId,
        packagebagId: this.packagebagId,
        regId: this.regId
      };
      getUserCourseStudyDetail(data).then(res => {
        if (res.code == 200) {
          this.baseInfoCatalogList = res.data.courseCatalogList;
          this.overStatus = res.data.overStatus; //是1是已学完
          this.courseId = res.data.courseId;
          this.hasQuestionnaire = res.data.hasQuestionnaire;
 

          if(this.overStatus ==1 && this.satisficing ==1 && this.hasQuestionnaire ==false){ //满意度调查
            /**保利威替换 start */
            // this.player.j2s_pauseVideo(); // 暂停播放当前视频
            /**保利威替换 end */
            /**播放器 start */
            this.$refs.ycyPlayer.pause(); // 暂停播放当前视频
            /**播放器 end */
            this.isQuestionShow =true;  
          }
          //调查问卷
          if(this.overStatus==1 && this.questionnaireFlag ==1){
            // 获取已经弹窗过的课程
            const isShowedList = JSON.parse(localStorage.getItem('isShowedList')) || [];
            // 当前视频是否弹出过
            const indexNow = isShowedList.findIndex(item=>item==this.courseId)
            // 如果没有弹出过，则存入数组
            if(indexNow==-1){
              isShowedList.push(this.courseId)
              localStorage.setItem('isShowedList',JSON.stringify(isShowedList))
              this.evaluationVisible = true
            }
          }
          // if(this.ccId == this.playData.ccId){
          //   this.ccId = this.playData.ccId
          //   if(this.playData.practicePlayFlag == 1){
          //     this.practicePopupDialog = true
          //     /**保利威替换 start */
          //     // this.player.j2s_pauseVideo(); 
          //     /**保利威替换 end */

          //     /**播放器 start */
          //     this.$refs.ycyPlayer.pause()
          //     /**播放器 end */
          //   }
          // }else{
          //   if(this.practicePlayFlag ==1){
          //     this.practicePopupDialog = true
          //     /**保利威替换 start */
          //     // this.player.j2s_pauseVideo(); 
          //     /**保利威替换 end */

          //     /**播放器 start */
          //     this.$refs.ycyPlayer.pause()
          //     /**播放器 end */
          //   }
          // }
          console.log('this.ccId6666',this.ccId,this.playData.ccId)
          console.log('sessionStorage',sessionStorage.getItem("practiceisFlag"))
          console.log('courseOver',this.courseOver,this.practicePlayFlag)


          if (this.ccId == this.playData.ccId) {
            this.ccId = this.playData.ccId;
            this.ccName = this.playData.ccName;
            // sessionStorage.setItem("practiceisFlag", true)
            if (
              this.playData.courseOver == 1 &&
              this.playData.practicePlayFlag == 1 &&
              JSON.parse(sessionStorage.getItem("practiceisFlag"))
            ) {
              console.log('wx-fff')
              this.practicePopupDialog = true;
              /**保利威替换 start */
              // this.player.j2s_pauseVideo(); 
              /**保利威替换 end */

              /**播放器 start */
              this.$refs.ycyPlayer.pause()
              /**播放器 end */
              sessionStorage.setItem("practiceisFlag", false);
            }
          } else {
            // sessionStorage.setItem("practiceisFlag", true)
            if (
              this.courseOver == 1 &&
              this.practicePlayFlag == 1 &&
              JSON.parse(sessionStorage.getItem("practiceisFlag"))
            ) {
              console.log('wx-ggg')
              this.practicePopupDialog = true;
              /**保利威替换 start */
              // this.player.j2s_pauseVideo();
              /**保利威替换 end */

              /**播放器 start */
              this.$refs.ycyPlayer.pause()
              /**播放器 end */

              sessionStorage.setItem("practiceisFlag", false);
            }
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //选中某一条视频进行播放
    play(
      vid,
      ccId,
      courseDelayTime,
      index,
      sub,
      courseOver,
      resouceHours,
      practicePlayFlag,
      exerciseId,
      ccName
    ) {
      const getVideoIdsParams = { 
        ccId,
        regId:this.regId
      }
      getVideoIds(getVideoIdsParams).then(getVideoIdsRes=>{
        
      this.playObj = {
        vid: vid,
        ccId: ccId,
        courseDelayTime: courseDelayTime,
        index: index,
        sub: sub,
        courseOver: courseOver,
        resouceHours: resouceHours,
        practicePlayFlag: practicePlayFlag,
        exerciseId: exerciseId
      };
      this.courseOver = courseOver;
      this.goExerciseId = exerciseId;
      // console.log("goExerciseId", this.goExerciseId);
      this.practicePlayFlag = practicePlayFlag;
      this.ccName = ccName;
      if (this.practicePlayFlag == 1) {
        sessionStorage.setItem("practiceisFlag", true);
      }
      this.getnoticeInLearning();
      this.firstTake = false;
      this.midTake = false;
      this.lastTake = false;
      console.log(
        "是否需要",
        this.courseConfig.camera,
        hasWebcam,
        isWebcamAlreadyCaptured
      );
      if (this.courseConfig.camera) {
        if (!hasWebcam) {
          that.$message.warning({
            message: "没有摄像头，请安装摄像头！",
            duration: 3000
          });
          clearInterval(this.isWatch);
          // history.go(-1)
          that.$router.push({
            path: "/courseDetail",
            query:{
              studyEntpId: that.$route.query.studyEntpId
            }
          });
          return;
        } else {
          if (!isWebcamAlreadyCaptured) {
            that.$message.warning({
              message:
                "捕获摄像头失败，请允许网页使用您的摄像头或重新安装摄像头！刷新后重试",
              duration: 3000
            });
            clearInterval(this.isWatch);
            // history.go(-1)
            that.$router.push({
              path: "/courseDetail",
              query:{
                studyEntpId: that.$route.query.studyEntpId
              }
            });
            return;
          }
        }
      }
      // ----------------------------- start 已播放完的视频重新播放 -- 验证人脸 -- 弹出弹窗 start -----------------------------
      // if (courseOver == 1 && that.courseConfig.camera) {
      //   that.dialogTableVisible = true;
      //   /**保利威替换 start */
      //   // that.player.j2s_pauseVideo();
      //   /**保利威替换 end */

      //   /**播放器 start */
      //   that.$refs.ycyPlayer.pause()
      //   /**播放器 end */
      // }
      // ----------------------------- end 已播放完的视频重新播放 -- 验证人脸 -- 弹出弹窗 end -----------------------------
      console.log('1111ccId',ccId,that.playData.ccId,that.ccId)
      if (ccId == that.playData.ccId) {
        ccId = that.playData.ccId;
        that.ccName = that.playData.ccName;
        // sessionStorage.setItem("practiceisFlag", true)
        if (
          that.playData.courseOver == 1 &&
          that.playData.practicePlayFlag == 1 &&
          JSON.parse(sessionStorage.getItem("practiceisFlag"))
        ) {
          console.log('wx-hhh',that.ccId,that.playData.ccId,ccId)
          that.practicePopupDialog = true;
          /**保利威替换 start */
          // that.player.j2s_pauseVideo();
          /**保利威替换 end */

          /**播放器 start */
          that.$refs.ycyPlayer.pause()
          /**播放器 end */
          sessionStorage.setItem("practiceisFlag", false);
        }
      } else {
        // sessionStorage.setItem("practiceisFlag", true)
        if (
          courseOver == 1 &&
          that.practicePlayFlag == 1 &&
          JSON.parse(sessionStorage.getItem("practiceisFlag"))
        ) {
          console.log('wx-bbb')
          that.practicePopupDialog = true;
          /**保利威替换 start */
          // that.player.j2s_pauseVideo();
          /**保利威替换 end */
          /**播放器 start */
          that.$refs.ycyPlayer.pause();
          /**播放器 end */
          sessionStorage.setItem("practiceisFlag", false);
        }
      }

      console.log(hasWebcam, isWebcamAlreadyCaptured, 888);
      // this.player.destroy();
      // console.log("打印历史播放时长", this.start)
      // console.log("打印所有播放参数", vid, ccId, courseDelayTime, index, sub, courseOver, resouceHours)
      if (!courseDelayTime) {
        courseDelayTime = 0;
      }
      // console.log("打印播放修改后参数", courseDelayTime)
      clearInterval(this.takePhotoInter);
      if (that.resData.limitClassHour) {
        let data = {};
        data.courseId = this.courseId;
        getStudyccCountToday(data).then(ressssss => {
          if (ressssss.data >= that.resData.limitClassHour) {
            // console.log('111', ressssss.data >= that.resData.limitClassHour)
            if (courseOver == 1 || courseOver == 0) {
              that.playObj = {
                vid: vid,
                ccId: ccId,
                courseDelayTime: courseDelayTime,
                index: index,
                sub: sub,
                courseOver: courseOver,
                resouceHours: resouceHours,
                practicePlayFlag: practicePlayFlag,
                exerciseId: exerciseId
              };
              let allSS =
                resouceHours.slice(0, 2) * 1 * 60 * 60 * 1000 +
                resouceHours.slice(3, 5) * 1 * 60 * 1000;
              that.takePhotoTime = allSS / that.takePhotoCount;
              that.needPhotoTime = allSS / that.needPhotoCount;
              /**保利威替换 start */
              // that.player.destroy(); // 销毁播放器，包括HTML5和flash播放器
              /**保利威替换 end */
              that.resouceHours = resouceHours;
              $("#player").css("display", "block");
              $("#buylink").css("display", "none");
              $("#startScreen").css("display", "none");
              that.current = index;
              that.select = index + "s";
              /**保利威替换 start */
              // that.vid = vid;
              /**保利威替换 end */
              /**播放器 start */
              let $vid = vid
              /**播放器 end */
              that.ccId = ccId;
              that.start = courseDelayTime;
              that.autoPlay = true;
              that.liSelected = index + "-" + sub;
              that.courseOver = courseOver;
              that.playerStart($vid); //播放器 此处加了一个入参
              // that.takePhotoInter = setInterval(function () {
              //   if (that.courseConfig.camera) {
              //     that.dialogTableVisible = true
              //     that.player.j2s_pauseVideo();
              //   }
              // }, 500)
            } else {
              this.$message({
                message: "当日可学习课时已学完，请明日在进行学习",
                type: "warning",
                duration: "2000"
              });
              clearInterval(that.isWatch);
            }
          } else {
            that.playObj = {
              vid: vid,
              ccId: ccId,
              courseDelayTime: courseDelayTime,
              index: index,
              sub: sub,
              courseOver: courseOver,
              resouceHours: resouceHours,
              exerciseId: exerciseId
            };
            let allSS =
              resouceHours.slice(0, 2) * 1 * 60 * 60 * 1000 +
              resouceHours.slice(3, 5) * 1 * 60 * 1000;
            that.takePhotoTime = allSS / that.takePhotoCount;
            that.needPhotoTime = allSS / that.needPhotoCount;
            /**保利威替换 start */
            // that.player.destroy(); // 销毁播放器，包括HTML5和flash播放器
            /**保利威替换 end */
            that.resouceHours = resouceHours;
            $("#player").css("display", "block");
            $("#buylink").css("display", "none");
            $("#startScreen").css("display", "none");
            that.current = index;
            that.select = index + "s";
            /**保利威替换 start */
            // that.vid = vid;
            /**保利威替换 end */
            /**播放器 start */
            let $vid = vid
            /**播放器 end */
            that.ccId = ccId;
            that.start = courseDelayTime;
            that.autoPlay = true;
            that.liSelected = index + "-" + sub;
            that.courseOver = courseOver;
            that.playerStart($vid); //播放器 此处加了一个入参
            // that.takePhotoInter = setInterval(function () {
            //   if (that.courseConfig.camera) {
            //     that.dialogTableVisible = true
            //     that.player.j2s_pauseVideo();
            //   }
            // }, 500)
          }
        });
      } else {
        that.playObj = {
          vid: vid,
          ccId: ccId,
          courseDelayTime: courseDelayTime,
          index: index,
          sub: sub,
          courseOver: courseOver,
          resouceHours: resouceHours,
          practicePlayFlag: practicePlayFlag,
          exerciseId: exerciseId
        };
        let allSS =
          resouceHours.slice(0, 2) * 1 * 60 * 60 * 1000 +
          resouceHours.slice(3, 5) * 1 * 60 * 1000;
        that.takePhotoTime = allSS / that.takePhotoCount;
        that.needPhotoTime = allSS / that.needPhotoCount;
        if(that.player !=null){
          /**保利威替换 start */
          // that.player.destroy(); // 销毁播放器，包括HTML5和flash播放器
          /**保利威替换 end */
        }
        that.isPdf = false;
        that.resouceHours = resouceHours;
        $("#player").css("display", "block");
        $("#buylink").css("display", "none");
        $("#startScreen").css("display", "none");
        that.current = index;
        that.select = index + "s";
        /**保利威替换 start */
        // that.vid = vid;
        /**保利威替换 end */
        /**播放器 start */
        let $vid = vid
        /**播放器 end */
        that.ccId = ccId;
        that.start = courseDelayTime;
        that.autoPlay = true;
        that.liSelected = index + "-" + sub;
        that.courseOver = courseOver;
        that.playerStart($vid); //播放器 此处加了一个入参
        // that.takePhotoInter = setInterval(function () {
        //   if (that.courseConfig.camera) {
        //     that.dialogTableVisible = true
        //     that.player.j2s_pauseVideo();
        //   }
        // }, 500)
      }
    })
    },

    // 普通课件下载
    linkOpenPage(index,sub,ccId,courseOver,practicePlayFlag,exerciseId,coursewareUrl,ccName) {
      this.courseOver = courseOver;
      this.goExerciseId = exerciseId;
      this.ccId = ccId
      this.practicePlayFlag = practicePlayFlag;
      this.ccName = ccName
      if (this.practicePlayFlag == 1) {
        sessionStorage.setItem("practiceisFlag", true);
      }
          if (that.ccId == that.playData.ccId) {
        that.ccId = that.playData.ccId;
        that.ccName = that.playData.ccName;
        // sessionStorage.setItem("practiceisFlag", true)
        if (
          that.playData.courseOver == 1 &&
          that.playData.practicePlayFlag == 1 &&
          JSON.parse(sessionStorage.getItem("practiceisFlag"))
        ) {
          console.log('wx-aaa')
          that.practicePopupDialog = true;
          /**保利威替换 start */
          // that.player.j2s_pauseVideo();
          /**保利威替换 end */
          /**播放器 start */
          that.$refs.ycyPlayer.pause();
          /**播放器 end */
          sessionStorage.setItem("practiceisFlag", false);
        }
      } else {
        // sessionStorage.setItem("practiceisFlag", true)
        if (
          courseOver == 1 &&
          that.practicePlayFlag == 1 &&
          JSON.parse(sessionStorage.getItem("practiceisFlag"))
        ) {
          console.log('wx-ccc')
          that.practicePopupDialog = true;
          /**保利威替换 start */
          // that.player.j2s_pauseVideo();
          /**保利威替换 end */
          /**播放器 start */
          that.$refs.ycyPlayer.pause();
          /**播放器 end */
          sessionStorage.setItem("practiceisFlag", false);
        }
      }

      let data = {
        packagebagId: this.packagebagId, // 套餐包Id
        regId: this.regId,
        courseId: this.courseId, // 课程Id
        ccId: ccId, //视频VID
        courseDelayTime: 1, //视频播放时长
        courseOver: 1,
        studyEntpId: this.$route.query.studyEntpId
      };
      saveUserStudyTime(data).then(res => {
        if (res.code ==200) {
          that.getCourseCatalog()
          that.current = index;
          that.select = index + 's';
          that.liSelected = index + "-" + sub;
          if(that.player){
            /**保利威替换 start */
            // that.player.j2s_pauseVideo();
            /**保利威替换 end */
            /**播放器 start */
            that.$refs.ycyPlayer.pause();
            /**播放器 end */
          }
          if(coursewareUrl !=null){
            const extension = coursewareUrl.substring(coursewareUrl.lastIndexOf('.') + 1).toLowerCase();
            if(extension =='pdf'){
              this.isPdf = true
              this.pdfLink = coursewareUrl
            }else if(extension =='txt'){
              let strData = new Blob([coursewareUrl], { type: 'text/plain;charset=utf-8' });
              saveAs(strData,ccName);
            }else{
              window.open(coursewareUrl)
              }
            }
        } else {
          this.$message.error(res.message);
          if (res.code == 2202) { //登陆失效
            /**保利威替换 start */
            // this.player.destroy()
            /**保利威替换 end */
            this.$alert('账号登录失效，请退出后重新登录！', '提示', {
              confirmButtonText: '确定',
              showClose: false,
              callback: action => {
                this.$router.push({
                  name: 'home'
                })
                sessionStorage.setItem("$isUserLogin", false)
              }
            });
          } else if (res.code == 2203) {
            that.abnormalOldPlayTime = JSON.parse(JSON.stringify(that.oldPlayTime));
            this.$message({
              type: 'warning',
              message: res.message
            });
            // that.play(that.playObj.vid, that.playObj.ccId, that.playObj.courseDelayTime, that.playObj.index, that.playObj.sub, that.playObj.courseOver, that.playObj.resouceHours);
            // that.player.j2s_seekVideo(that.abnormalOldPlayTime)
          }
        }
      })
    },
    //播放器的记时功能
    render() {
      if (
        
        /**保利威替换 start */
        // this.player != undefined &&
        // this.player.j2s_getCurrentTime != undefined
        /**保利威替换 end */
        /**播放器 start */
        this.$refs.ycyPlayer != undefined && 
        this.$refs.ycyPlayer.getCurrentTime != undefined
        /**播放器 end */
      ) {
        /**保利威替换 start */
        // this.playTime = this.player.j2s_getCurrentTime();
        /**保利威替换 end */
        /**播放器 start */
        this.playTime = this.$refs.ycyPlayer.getCurrentTime();
        /**播放器 end */
        this.oldPlayTime = this.playTime;
        /**保利威替换 start */
        // let firsrTime = Math.ceil(this.player.j2s_getDuration() *0.1);
        // let midTime = Math.ceil(this.player.j2s_getDuration() *0.5);
        // let lastTime = Math.ceil(this.player.j2s_getDuration() *0.8);
        /**保利威替换 end */
        /**播放器 start */
        let firsrTime = Math.ceil(this.$refs.ycyPlayer.getDuration() *0.1);
        let midTime = Math.ceil(this.$refs.ycyPlayer.getDuration() *0.5);
        let lastTime = Math.ceil(this.$refs.ycyPlayer.getDuration() *0.8);
        /**播放器 end */
        console.log(999,this.needPhotoCount, firsrTime,midTime,lastTime, Math.ceil(this.playTime))
        if(this.needPhotoCount ==1){
          if (
            this.courseConfig.camera &&
            midTime == Math.ceil(this.playTime) &&
            !this.midTake
          ) {
            // 播放到视频中部
            /**保利威替换 start */
            // this.player.j2s_pauseVideo(); // 暂停播放当前视频
            /**保利威替换 end */
            /**播放器 start */
            this.$refs.ycyPlayer.pause();
            /**播放器 end */
            this.dialogTableVisible = true;
            this.midTake = true; //记录已经进行中间拍照
          }
        }else{
          if(this.playData.courseOver != 1 || this.courseOver !=1){
            if( 
              this.courseConfig.camera &&
              firsrTime == Math.ceil(this.playTime) &&
              !this.firstTake
            ){
              // 播放到视频10%
              /**保利威替换 start */
              // this.player.j2s_pauseVideo(); // 暂停播放当前视频
              /**保利威替换 end */
              /**播放器 start */
              this.$refs.ycyPlayer.pause();
              /**播放器 end */
              this.dialogTableVisible = true;
              this.firstTake = true; //记录已经进行10%拍照
            }else if (
                this.courseConfig.camera &&
                midTime == Math.ceil(this.playTime) &&
                !this.midTake
            ) {
              // 播放到视频中部(50%)
              /**保利威替换 start */
              // this.player.j2s_pauseVideo(); // 暂停播放当前视频
              /**保利威替换 end */
              /**播放器 start */
              this.$refs.ycyPlayer.pause();
              /**播放器 end */
              this.dialogTableVisible = true;
              this.midTake = true; //记录已经进行50%拍照
            }else if( 
              this.courseConfig.camera &&
              lastTime == Math.ceil(this.playTime) &&
              !this.lastTake
            ){
              // 播放到视频尾部80%
              /**保利威替换 start */
              // this.player.j2s_pauseVideo(); // 暂停播放当前视频
              /**保利威替换 end */
              /**播放器 start */
              this.$refs.ycyPlayer.pause();
              /**播放器 end */
              this.dialogTableVisible = true;
              this.lastTake = true; //记录已经进行80%拍照
            }
          }
        }
        // console.log('that.courseConfig.completeRateFlag', that.courseConfig.completeRateFlag)
        // console.log('this.isSave', !this.isSave)
        // console.log('that.courseConfig', that.courseConfig)
        if (
          that.courseConfig.completeRateFlag &&
          that.courseConfig.completeRateFlag != ""
        ) {
          let resouceHours =
            this.timeToSec(this.resouceHours) *
            (new Number(that.courseConfig.completeRateFlag) / 100);
          // console.log("=====>", this.playTime, resouceHours)
          if (this.playTime >= resouceHours) {
            //根据配置来
            if (!this.isSave) {
              if (this.ccId == this.playData.ccId) {
                this.ccId = this.playData.ccId;
                this.ccName = this.playData.ccName;
                // sessionStorage.setItem("practiceisFlag", true)
                if (
                  this.playData.practicePlayFlag == 1 &&
                  JSON.parse(sessionStorage.getItem("practiceisFlag"))
                ) {
                  console.log('wx-ddd')
                  this.practicePopupDialog = true;
                  /**保利威替换 start */
                  // this.player.j2s_pauseVideo();
                  /**保利威替换 end */
                  /**播放器 start */
                  this.$refs.ycyPlayer.pause();
                  /**播放器 end */
                  sessionStorage.setItem("practiceisFlag", false);
                }
              } else {
                // sessionStorage.setItem("practiceisFlag", true)
                if (
                  this.practicePlayFlag == 1 &&
                  JSON.parse(sessionStorage.getItem("practiceisFlag"))
                ) {
                  console.log('wx-eee')
                  this.practicePopupDialog = true;
                  /**保利威替换 start */
                  // this.player.j2s_pauseVideo();
                  /**保利威替换 end */
                  /**播放器 start */
                  this.$refs.ycyPlayer.pause();
                  /**播放器 end */
                  sessionStorage.setItem("practiceisFlag", false);
                }
              }

              // if(that.practicePlayFlag ==1 && sessionStorage.getItem("practiceisFlag")){
              //   that.practicePopupDialog = true
              //   that.player.j2s_pauseVideo();
              //   sessionStorage.setItem("practiceisFlag", false)

              // }
              this.saveUserCourseStudingData(1);
            }
          }
        } else {
          let resouceHours = this.timeToSec(this.resouceHours) - 60;
          if (this.playTime >= resouceHours) {
            //还剩1分钟时调用接口
            if (!this.isSave) {
              this.saveUserCourseStudingData(1);
            }
          }
        }
      }
    },
    //伸缩章节
    pulling(cataLog, event) {
      var el = event.currentTarget;
      let idName = "#" + cataLog;
      let ispull = $(idName).attr("ispull");
      if (ispull == "true") {
        $(idName).removeClass("show");
        $(idName).attr("ispull", "false");
        $(el)
          .find(".up")
          .hide();
        $(el)
          .find(".down")
          .show();
      } else {
        $(idName).addClass("show");
        $(idName).attr("ispull", "true");
        $(el)
          .find(".down")
          .hide();
        $(el)
          .find(".up")
          .show();
      }
    },
    //获取屏幕高度
    getScreenHeight() {
      var clientHeight = document.documentElement.clientHeight;
      var clientWidth = document.documentElement.clientWidth;
      // console.log("可视高度",clientHeight,"可视宽度",clientWidth)
      this.playHeight = clientHeight - 60;
      // console.log(this.playHeight)
      $("#videoPlay").height(this.playHeight);
      $("#playerBox").height(this.playHeight);
      $("#player").height(this.playHeight-20);
      $("#videoList").height(this.playHeight);
      $("#videoBox").height(this.playHeight);
      $("#buylink").height(this.playHeight);
      $("#startScreen").height(this.playHeight);
      $("#pdfShowStyle").height(this.playHeight-20)
    },
    //路由回退
    goBack() {
      sessionStorage.setItem("coursePlayGoBack", 1);
      this.$router.replace({
        path: "/courseDetail",
        name: "courseDetail",
        params: {
          courseId: this.courseId,
          packagebagId: this.packagebagId
        },
        query:{
          studyEntpId: this.$route.query.studyEntpId
        }
      });
      // 返回上一页后  当前页面关闭摄像头
      this.$refs.camera.stopNavigator();
    },

    //将时分秒转换成秒
    timeToSec(time) {
      // console.log(time, 'time');
      var hour = time.split(":")[0];
      var min = time.split(":")[1];
      var sec = time.split(":")[2];
      var s = Number(hour * 3600) + Number(min * 60) + Number(sec);
      return s;
    },
    handleOpen() {},
    open() {
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h("p", null, "检测到您已使用其他账号登录，该窗口用户已被替换！"),
          h("p", null, "请确认当前账号是否正确")
          // h('i', { style: 'color: teal' }, 'VNode')
        ]),
        showClose: false,
        confirmButtonText: "确定",
        callback: action => {
          this.$router.push({
            name: "home"
          });
          // sessionStorage.setItem("$isUserLogin",false)
        }
      });
    },

    addCourseComment() {
      var data = {
        commentContent: this.formRecord.commentContent,
        courseId: this.courseId,
        courseName: this.courseName,
        ccId: that.playObj.ccId
      };
      addCourseComment(data).then(res => {
        if (res.code == 200) {
          that.formRecord.commentContent = "";
          this.$message({
            type: "success",
            message: "发表成功",
            duration: "2000"
          });
          that.getCourseCommentListHome("记录");
        }
      });
    },

    getCourseCommentListHome(v) {
      that.tabLeftType = v;
      var data = {
        courseId: this.courseId,
        pageSize: 90,
        pageNum: 1
      };
      if (that.radioPl == 1) {
        data.cateId = that.playObj.ccId;
      }
      getCourseCommentListHome(data).then(res => {
        if (res.code == 200) {
          res.data.forEach(function(obj) {
            obj.spStatus = false;
          });
          this.courseCommentListHome = res.data;
        }
      });
    },

    /**
     *  看课拍照
     */
    getUlr(imgUrl) {
      // console.log(imgUrl, 'imgUrl')
      if (imgUrl == "没有检测到头像") {
        /**保利威替换 start */
        // that.player.j2s_pauseVideo();
        /**保利威替换 end */
        /**播放器 start */
        that.$refs.ycyPlayer.pause();
        /**播放器 end */
        that
          .$confirm(
            "系统捕获摄像头异常，建议重新启动摄像头后，再开始进行学习",
            "提示",
            {
              confirmButtonText: "我知道了",
              showCancelButton: false,
              closeOnClickModal: false,
              type: "warning"
            }
          )
          .then(() => {
            that.$router.go(-1);
          })
          .catch(() => {});
      } else {
        that.imgUrl = imgUrl;
        let data = {
          courseId: that.courseId, // 课程Id
          ccId: that.ccId, //视频VID
          photoUrl: imgUrl,
          regId: that.regId,
          packagebagId: that.packagebagId,
          studyEntpId: this.$route.query.studyEntpId
        };
        saveStudyPhoto(data).then(res => {
          // 保存照片
          if (res.code == 200) {
            this.loadingPhoto = false;
            setTimeout(() => {
              this.isDisabled = false // 点击一次时隔两秒后才能再次点击
            }, 2000)
            this.resDataStatus = res.data.status
            if(this.comparison==1){
              this.comparisonMsg = res.message;
            }else{
              this.$message.success({
                duration: 1500,
                message: res.message
              });
            }
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    handleClose() {
      if (this.imgUrl == "") {
        this.$message({
          type: "warning",
          message: "请点击拍照"
        });
      } else {
        this.$confirm(
          "请检查已经拍的照片是否是符合规范的照片（人脸全部显示在拍摄区域内），照片不规范将会审核不通过，导致您重新看课",
          "提示",
          {
            confirmButtonText: "已检查，继续看课",
            cancelButtonText: "去检查",
            type: "warning",
            showClose:false, //是否显示右上角的x
            closeOnClickModal:false, //是否可以点击空白处关闭弹窗
          }
        )
          .then(() => {
            this.dialogTableVisible = false;
            /**保利威替换 start */
            // this.player.j2s_resumeVideo();
            /**保利威替换 end */
            /**播放器 start */
            this.$refs.ycyPlayer.play();
            /**播放器 end */

            this.imgUrl = "";
          })
          .catch(() => {});
      }
    },
    getUlr2(imgUrl) {
      if (imgUrl == "没有检测到头像") {
        /**保利威替换 start */
        // this.player.j2s_pauseVideo();
        /**保利威替换 end */
        /**播放器 start */
        this.$refs.ycyPlayer.pause();
        /**播放器 end */
        this.$confirm(
          "系统捕获摄像头异常，建议重新启动摄像头后，再开始进行学习",
          "提示",
          {
            confirmButtonText: "我知道了",
            showCancelButton: false,
            closeOnClickModal: false,
            type: "warning"
          }
        )
          .then(() => {
            this.$router.go(-1);
          })
          .catch(() => {});
      } else {
        this.imgUrl = imgUrl;
        let data = {
          courseId: that.courseId, // 课程Id
          ccId: that.ccId, //视频VID
          photoUrl: imgUrl,
          regId: that.regId,
          packagebagId: that.packagebagId,
          studyEntpId: this.$route.query.studyEntpId
        };
        saveStudyPhoto(data).then(res => {
          if (res.code == 200) {
            this.loadingPhoto = false;
            setTimeout(() => {
              this.isDisabled = false // 点击一次时隔两秒后才能再次点击
            }, 2000)
            this.resDataStatus = res.data.status
            if(this.comparison==1){
              this.comparisonMsg = res.message;
            }else{
              this.$message.success({
                duration: 1500,
                message: res.message
              });
            }
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    savePhone() {
      that.isDisabled = true;
      that.loadingPhoto = true;
      that.$refs.camera2.setImage();
    },
    resumeVideo() {
      let _that = this;
      if (_that.imgUrl == "") {
        _that.$message({
          type: "warning",
          message: "请点击拍照"
        });
      } else {
        _that
          .$confirm(
            "请检查已经拍的照片是否是符合规范的照片（人脸全部显示在拍摄区域内），照片不规范将会审核不通过，导致您重新看课",
            "提示",
            {
              confirmButtonText: "已检查，继续看课",
              cancelButtonText: "去检查",
              type: "warning",
              showClose:false, //是否显示右上角的x
              closeOnClickModal:false, //是否可以点击空白处关闭弹窗
            }
          )
          .then(() => {
            if(that.resDataStatus ==-1){
              that.$message({
                type: 'error',
                message:that.comparisonMsg
              });
             }else{
              _that.imgUrl = "";
              _that.comparisonMsg = '';
              _that.dialogTableVisible = false;
              clearInterval(_that.takePhotoInter);
              let courseList = [];
              courseList = localStorage.getItem("courseIds")
                ? localStorage.getItem("courseIds").split(",")
                : localStorage.getItem("courseIds");
              if (courseList) {
                courseList.map(item => {
                  if (_that.courseId == item) {
                    _that.evaluationVisible = false;
                  } else {
                    _that.evaluationVisible = true;
                  }
                });
              }
              /**保利威替换 start */
              // _that.player.j2s_resumeVideo();
              /**保利威替换 end */

              /**播放器 start */
              _that.$refs.ycyPlayer.play();
              /**播放器 end */

              that.resDataStatus =-1
            }
          })
          .catch(() => {});
      }
    },
    //检测是否安装摄像头
    checkDeviceSupport(callback) {
      if (!canEnumerate) {
        return;
      }
      if (
        !navigator.enumerateDevices &&
        window.MediaStreamTrack &&
        window.MediaStreamTrack.getSources
      ) {
        navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(
          window.MediaStreamTrack
        );
      }
      if (!navigator.enumerateDevices && navigator.enumerateDevices) {
        navigator.enumerateDevices = navigator.enumerateDevices.bind(navigator);
      }
      if (!navigator.enumerateDevices) {
        if (callback) {
          callback();
        }
        return;
      }
      MediaDevices = [];
      navigator.enumerateDevices(function(devices) {
        devices.forEach(function(_device) {
          var device = {};
          for (var d in _device) {
            device[d] = _device[d];
          }
          if (device.kind === "audio") {
            device.kind = "audioinput";
          }
          if (device.kind === "video") {
            device.kind = "videoinput";
          }
          var skip;
          MediaDevices.forEach(function(d) {
            if (d.id === device.id && d.kind === device.kind) {
              skip = true;
            }
          });
          if (skip) {
            return;
          }
          if (!device.deviceId) {
            device.deviceId = device.id;
          }
          if (!device.id) {
            device.id = device.deviceId;
          }
          if (!device.label) {
            device.label = "Please invoke getUserMedia once.";
            if (!isHTTPs) {
              device.label =
                "HTTPs is required to get label of this " +
                device.kind +
                " device.";
            }
          } else {
            if (device.kind === "videoinput" && !isWebcamAlreadyCaptured) {
              isWebcamAlreadyCaptured = true;
            }
            if (device.kind === "audioinput" && !isMicrophoneAlreadyCaptured) {
              isMicrophoneAlreadyCaptured = true;
            }
          }
          if (device.kind === "audioinput") {
            hasMicrophone = true;
          }
          if (device.kind === "audiooutput") {
            hasSpeakers = true;
          }
          if (device.kind === "videoinput") {
            hasWebcam = true;
          }
          // there is no 'videoouput' in the spec.
          MediaDevices.push(device);
        });
        if (callback) {
          callback();
        }
      });
    },

    // 访问用户媒体设备
    getUserMedia(constrains, success, error) {
      if (!navigator.mediaDevices) {
        error({
          name: "环境错误",
          message: "请确定是否处于https协议环境下"
        });
        return;
      }
      if (navigator.mediaDevices.getUserMedia) {
        //最新标准API
        navigator.mediaDevices
          .getUserMedia(constrains)
          .then(success)
          .catch(error);
      } else if (navigator.webkitGetUserMedia) {
        //webkit内核浏览器
        navigator
          .webkitGetUserMedia(constrains)
          .then(success)
          .catch(error);
      } else if (navigator.mozGetUserMedia) {
        //Firefox浏览器
        navagator
          .mozGetUserMedia(constrains)
          .then(success)
          .catch(error);
      } else if (navigator.getUserMedia) {
        //旧版API
        navigator
          .getUserMedia(constrains)
          .then(success)
          .catch(error);
      } else {
        error({
          name: "兼容异常",
          message: "你的浏览器不支持访问用户媒体设备"
        });
        // this.mediaMessage = "你的浏览器不支持访问用户媒体设备";
      }
    },

    getnoticeInLearning() {
      noticeInLearning().then(res => {
        if (res.data) {
          this.noticeData = res.data;
          let noticeData = JSON.parse(localStorage.getItem("noticeData"));
          if (!noticeData) {
            localStorage.setItem("noticeData", JSON.stringify(res.data));
            this.visible = true;
          } else if (noticeData.noticeId != res.data.noticeId) {
            localStorage.setItem("noticeData", JSON.stringify(res.data));
            this.visible = true;
          }
        }
      });
    },
    // 习题弹窗关闭
    close() {
      this.visible = false;
      this.$refs.examDialog = "";
      this.practicePopupDialog = false;
      let data = {
        courseId: this.courseId,
        packagebagId: this.packagebagId,
        regId: this.regId
      };
      getUserCourseStudyDetail(data).then(res => {
        this.baseInfoCatalogList = res.data.courseCatalogList;
        this.overStatus = res.data.overStatus; //是1是已学完
        this.courseId = res.data.courseId;
        //调查问卷
        if (this.overStatus == 1 && this.questionnaireFlag == 1) {
          // 获取已经弹窗过的课程
          const isShowedList =
            JSON.parse(localStorage.getItem("isShowedList")) || [];
          // 当前视频是否弹出过
          const indexNow = isShowedList.findIndex(
            item => item == this.courseId
          );
          // 如果没有弹出过，则存入数组
          if (indexNow == -1) {
            isShowedList.push(this.courseId);
            localStorage.setItem("isShowedList", JSON.stringify(isShowedList));
            this.evaluationVisible = true;
          }
        }
      });
    },
    //关闭习题弹窗
    handleTitleClose() {
      this.$confirm("是否确定关闭该弹窗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          this.$refs.examDialog = "";
          this.practicePopupDialog = false;
          let data = {
            courseId: this.courseId,
            packagebagId: this.packagebagId,
            regId: this.regId
          };
          getUserCourseStudyDetail(data).then(res => {
            this.baseInfoCatalogList = res.data.courseCatalogList;
            this.overStatus = res.data.overStatus; //是1是已学完
            this.courseId = res.data.courseId;
            //调查问卷
            if (this.overStatus == 1 && this.questionnaireFlag == 1) {
              // 获取已经弹窗过的课程
              const isShowedList =
                JSON.parse(localStorage.getItem("isShowedList")) || [];
              // 当前视频是否弹出过
              const indexNow = isShowedList.findIndex(
                item => item == this.courseId
              );
              // 如果没有弹出过，则存入数组
              if (indexNow == -1) {
                isShowedList.push(this.courseId);
                localStorage.setItem(
                  "isShowedList",
                  JSON.stringify(isShowedList)
                );
                this.evaluationVisible = true;
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //跳转另外的地址
    evaluationOpen() {
      sessionStorage.setItem("questionnaireFlag", this.questionnaireFlag);
      this.evaluationVisible = false;
      window.open(this.questionnaireUrl);
    }
  },
  watch: {
    /**播放start */
    // 监听拍照弹窗，弹出时关闭自动播放
    dialogTableVisible(val){
      if(val){
        this.autoPlay = false
      }else{
        this.autoPlay = true
      }
    },
    // 监听满意度，弹出时关闭自动播放
    practicePopupDialog(val){
      if(val){
        this.autoPlay = false
      }else{
        this.autoPlay = true
      }
    },
    // 监听问卷调查，弹出时关闭自动播放
    isQuestionShow(val){
      if(val){
        this.autoPlay = false
      }else{
        this.autoPlay = true
      }
    },
    /**播放end */

    "courseConfig.camera"(val) {
      if (val) {
        this.getUserMedia(
          {
            video: {
              width: 480,
              height: 480,
              facingMode: "user"
            } /* 前置优先 */
          },
          function(stream) {
            console.log("摄像头获取成功");
            // 兼容性处理
            // 监听流中断，流中断后将重新进行调用自身进行状态监测
            stream.oninactive = function() {
              alert("摄像头中断");
              console.log(that.courseConfig.camera);
              if (that.courseConfig.camera == true) {
                that.$message.warning({
                  message: "捕获摄像头失败，请安装摄像头！",
                  duration: 2000
                });
                clearInterval(that.isWatch);
                that.interval = null;
                that.$router.push({
                  path: "/courseDetail",
                  query:{
                    studyEntpId: that.$route.query.studyEntpId
                  }
                });
              }
            };
          },
          function() {
            let t = setTimeout(() => {
              clearInterval(t);
              console.log("失败");
              console.log(that.courseConfig.camera);
              if (that.courseConfig.camera == true) {
                that.$message.warning({
                  message: "捕获摄像头失败，请安装摄像头！",
                  duration: 2000
                });
                clearInterval(that.isWatch);
                that.interval = null;
                that.$router.push({
                  path: "/courseDetail",
                  query:{
                    studyEntpId: that.$route.query.studyEntpId
                  }
                });
              }
            }, 2000);
          }
        );
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/coursePlay2/coursePlay.js